<template>
  <form @submit.prevent="updateCarBrand()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          Edit Car Brand - {{ carBrand.name }}
        </h5>
        <button
          ref="modalCloseBtn"
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-4">
            <label for="">Car Type</label>
            <select class="form-control" v-model="formValue.car_type_id">
              <option
                :value="carType.id"
                v-for="carType in carTypeList"
                :key="carType.id"
              >
                {{ carType.name }}
              </option>
            </select>
          </div>
          <div class="col-sm-4">
            <label for="">Name</label>
            <input
              type="text"
              v-model="formValue.name"
              class="form-control"
              required
            />
          </div>
          <div class="col-sm-4">
            <label for="">Status</label>
            <select v-model="formValue.status" class="form-control" required>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button v-if="isLoading" class="btn btn-primary" type="button" disabled>
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </button>
        <button v-else class="btn btn-primary">Update</button>
      </div>
    </div>
  </form>
</template>

<script>
import http from '@/config/axios';

export default {
  props: ['carBrand', 'carTypeList'],
  data() {
    return {
      formValue: {
        car_type_id: null,
        name: null,
        status: null
      },
      isLoading: false
    };
  },
  watch: {
    carBrand: function () {
      this.formValue.car_type_id = this.carBrand.car_type_id;
      this.formValue.name = this.carBrand.name;
      this.formValue.status = this.carBrand.status;
    }
  },
  methods: {
    emptyFormValues() {
      for (const key in this.formValue) {
        this.formValue[key] = null;
      }
    },
    updateCarBrand() {
      this.isLoading = true;
      http
        .patch(`v2/settings/car-brands/${this.carBrand.id}`, this.formValue)
        .then((response) => {
          this.isLoading = false;
          if (response.status == 200) {
            this.$swal('Success', response.data.message, 'success');
            this.$refs.modalCloseBtn.click();
            this.emptyFormValues();
            this.$emit('refreshCarBrandList');
          } else {
            this.$swal('Error', 'Something went wrong!', 'error');
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          this.$swal('Error', 'Something went wrong!', 'error');
        });
    }
  }
};
</script>

<style scoped></style>
